<template>
    <div class>
        <div class="page-cnt">
            <!-- Left sidebar -->
            <div class="left-sidebar ex-has-btm">
                <SearchTour
                    :groupType="groupType"
                    :listVouchers="listVouchers"
                    :setErrorMessage="setErrorMessage"
                    :updateTourInfo="updateTourInfo"
                    v-if="renderSearchTour"
                ></SearchTour>

                <div class="content-wallet mt-4">
                    <!-- タブメニュー -->
                    <ul class="nav nav-tabs" v-show="isSubContract()">
                        <li class="nav-item">
                            <a
                                class="nav-link"
                                :class="{'active': screenType == constants.SubContractScreenType}"
                                @click="switchScreen(constants.SubContractScreenType)"
                            >
                                <i class="icon-sub-contract-red mr-2"></i>
                                {{$t('tab.sub_contract')}}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a
                                class="nav-link"
                                :class="{'active': screenType == constants.ChangeContractScreenType}"
                                @click="switchScreen(constants.ChangeContractScreenType)"
                            >
                                <i class="icon-change-sub-contract-red mr-2"></i>
                                {{$t('tab.change_contract')}}
                            </a>
                        </li>
                    </ul>
                    <div class="other-nav" v-show="screenType == constants.OtherContractScreenType">
                        <div class="active-tab">
                            <div class="tab-item">
                                <i class="icon-other-contract-red mr-2"></i>
                                {{$t('tab.other_contract')}}
                            </div>
                        </div>
                    </div>
                    <ul class="nav nav-tabs" v-show="screenType == constants.PartnerContractScreenType">
                        <li class="nav-item">
                            <div class="nav-link active">
                                <i class="icon-partner-contract-red mr-2"></i>
                                {{$t('tab.partner_contract')}}
                            </div>
                        </li>
                        <li class="nav-item"></li>
                    </ul>
                </div>

                <div class="mt-4 heading-breadcrumb">
                    <div v-if="screenType == constants.OtherContractScreenType">証憑明細登録 > 契約書 > その他</div>
                    <div v-else-if="screenType == constants.SubContractScreenType">証憑明細登録 > 契約書 > 業務委託契約書</div>
                    <div v-else-if="screenType == constants.ChangeContractScreenType">証憑明細登録 > 契約書 > 変更契約書</div>
                    <div v-else-if="screenType == constants.PartnerContractScreenType">証憑明細登録 > 契約書 > 委託先契約書</div>
                </div>

                <div class="content-wallet">
                    <div class="tab-content">
                        <div class="table-static">
                            <div v-for="(item, index) in contracts" :key="index">
                                <div class="table-heading">{{ item.month }}</div>
                                <div class="table-cnt">
                                    <ul class="lst-static">
                                        <li v-for="row in item.contracts" :key="row.id" :class="{'ex-highlight-row': activeRow == row.id}"
                                            @click="e=> { if (activeRow != row.id) detailContract(row.id); }">
                                            <voucher-row
                                                :screenType="constants.BeforeContractScreenType"
                                                :voucher="row">
                                            ></voucher-row>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 明細入力ボタン -->
                <div class="btns-btm">
                    <button class="btn btn-pink-44 w-100 ex-orange-light" @click="addVoucherCamera()">
                        <i class="icon-camera mr-2"></i>
                        {{ $t('voucher.button.add_details') }}
                    </button>
                </div>
            </div>
            <!-- /Left sidebar -->

            <!-- Main content -->
            <div class="main-cnt">
                <div class="content-white">
                    <TourInfo :setErrorMessage="setErrorMessage" :tourInfoProp="tourInfo"></TourInfo>
                    <div class="error-message-voucher" v-if="errorMessage">
                        <div class="d-flex">
                            <i class="icon-warning mr-2"></i>
                            <div class="errror-txt">
                                <p class="fs-14 text-red font600">{{$t('error.title')}}</p>
                                <p class="fs-14 text-red font600">{{ errorMessage }}</p>
                            </div>
                        </div>
                    </div>

                    <!-- preview File -->
                    <div class="content-body" v-if="previewFileUpload">
                        <preview-file-upload
                            :selectFiles="selectFiles"
                            :modeAddVoucher="goAddVoucher"
                            :cancelUpload="reset"
                            :uploadFiles.sync="uploadFiles"
                            :showThumb="showThumb"
                            :setErrorMessage="setErrorMessage"
                            :voucherType="voucherType"
                            :key="num"
                        ></preview-file-upload>
                    </div>

                    <!-- voucher Details -->
                    <div class="content-body" v-if="modeDetails">
                        <div class="d-flex">
                            <button class="btn btn-pink-53 w140 mr-3" @click="editVoucher">
                                <i class="icon-edit-w mr-2"></i>
                                {{$t('button.edit')}}
                            </button>
                            <button class="btn btn-gray-53 w140" data-toggle="modal" data-target="#modalDelete" :disabled="utils.isReadOnly()">
                                <i class="icon-trash mr-2"></i>
                                {{$t('button.delete')}}
                            </button>
                        </div>
                        <component v-bind:is="componentDetailsVoucher" :voucher="voucher" :history="history"></component>
                    </div>

                    <!-- add Voucher -->
                    <div class="content-body" v-if="modeAdd">
                        <component
                            v-bind:is="componentAddVoucher"
                            :setErrorMessage="setErrorMessage"
                            :voucherParams="voucherParams"
                            :modeEdit="modeEdit"
                            @voucherSuccess="voucherSuccess"
                            @cancelAdd="reset"
                            @showPreInputCopyModal="showPreInputCopyModal"
                            ref="addComponent"
                        ></component>

                    </div>

                    <div class="content-body" v-if="modeEdit">
                        <component
                            v-bind:is="componentEditVoucher"
                            :setErrorMessage="setErrorMessage"
                            :voucherParams="voucherParams"
                            :modeEdit="modeEdit"
                            @voucherSuccess="voucherSuccess"
                            @cancelAdd="reset"
                        ></component>
                    </div>
                </div>

            </div>
        </div>

        <!-- Modal show thumb file -->
        <show-img :setListFiles="setListFiles" :file="file"></show-img>

        <upload-file-modal
            :previewFiles="previewFiles"
            :setListFiles="setListFiles"
            :uploadFiles="uploadFiles"
        ></upload-file-modal>

        <DeleteVoucher
            :id="voucher.id"
            :getCashDetails="detailContract"
            :listVouchers="listVouchers"
            :groupType="groupType"
            :setErrorMessage="setErrorMessage"
            :reset="allReset"
        ></DeleteVoucher>

        <pre-input-copy
            @setVoucher="setVoucher"
            ref="preInputCopy"
        ></pre-input-copy>

    </div>
</template>

<script>
import { Constants } from "@/helpers/constants";
import Utils from "@/helpers/utils";
import DateUtils from '@/helpers/dateUtils';

import StorageService from "@/services/common/storage.service";
import VoucherService from "@/services/module/voucher.service";
import { AuthService } from "@/services/common/auth.service";

import TourInfo from "@/views/layout/pc/Tour/Info";
import SearchTour from "@/views/layout/pc/Tour/Search";
import UploadFileModal from "@/views/components/pc/Voucher/UploadFileModal";
import ShowImg from "@/views/components/pc/Voucher/ShowImg";
import PreviewFileUpload from "@/views/components/pc/Voucher/PreviewFileUpload";
import PreInputCopy from "@/views/components/pc/Voucher/PreInputCopy";
import DeleteVoucher from "@/views/components/pc/Voucher/DeleteVoucher";
import VoucherRow from '@/views/components/common/VoucherRow';


export default {
    components: {
        SearchTour,
        UploadFileModal,
        ShowImg,
        DeleteVoucher,
        PreviewFileUpload,
        TourInfo,
        PreInputCopy,
        VoucherRow,
    },
    name: "PcSubContracts",
    data () {
        return {
            constants: Constants,
            utils: Utils,
            renderSearchTour: true,
            groupType: Constants.GroupVoucherType.contract,
            screenType: "",
            tourInfo: "",
            file: "",
            uploadFiles: [],
            previewFileUpload: false,
            voucherType: "",
            errorMessage: "",
            num: 0,
            activeRow: "",

            // 各契約書リスト・先頭アイテム
            contracts: [],

            modeAdd: false,
            modeDetails: false,
            modeEdit: false,
            voucher: {},
            voucherParams: {},
            ocrData: "",
            contractId: "",
            history: [],
        };
    },
    computed: {
        componentDetailsVoucher: {
            get: function () {
                if (this.modeDetails) {
                    let templateId = Utils.getTemplateId(
                        this.voucher.voucher_type_id
                    );

                    if (!Utils.isEmptyStr(templateId)) {
                        return () =>
                            import(
                                `../Voucher/Details/Temp_` + templateId + `.vue`
                            );
                    }
                }
                return null;
            },
            set: function (newValue) {
                this.modeDetails = newValue;
            },
        },
        componentAddVoucher: {
            get: function () {
                if (this.modeAdd) {
                    this.voucherParams = {};
                    let templateId = Utils.getTemplateId(this.voucherType);
                    if (!Utils.isEmptyStr(templateId)) {
                        this.voucherParams.voucherTypeId = this.voucherType;
                        this.voucherParams.modeAdd = this.modeAdd;
                        let filePath = "";
                        if (this.ocrData.path) {
                            filePath = this.ocrData.path;
                        }
                        this.voucherParams.filePath = filePath;
                        let signature = false;
                        if (this.ocrData.signature) {
                            signature = this.ocrData.signature;
                        }
                        this.voucherParams.signature = signature;
                        if (!Utils.isEmptyObj(this.ocrData.ocr) && !Utils.isEmptyObj(this.ocrData.ocr.mapping)) {
                            let data = this.ocrData.ocr.mapping.template_mapping;
                            if (data.transaction_date && data.transaction_date[0]) {
                                this.voucherParams.transactionDate = new Date(data.transaction_date[0]);
                            };

                            if (data.account_name && data.account_name[0]) {
                                this.voucherParams.accountName = data.account_name[0];
                            };

                            if (data.amount && data.amount[0]) {
                                this.voucherParams.totalAmount = data.amount[0];
                            };
                        } else {
                            this.voucherParams.accountName = this.ocrData.accountName;
                            this.voucherParams.totalAmount = this.ocrData.totalAmount;
                        }

                        return () =>
                            import(
                                `../Voucher/Add/Temp_` + templateId + `.vue`
                            );
                    }
                }
                return null;
            },
            set: function (newValue) {
                this.modeAdd = newValue;
            },
        },
        componentEditVoucher: {
            get: function () {
                if (this.modeEdit) {
                    let templateId = Utils.getTemplateId(this.voucher.voucher_type_id);

                    if (!Utils.isEmptyStr(templateId)) {
                        this.voucherParams = {};
                        this.voucherParams.id = this.voucher.id;
                        this.voucherParams.voucherNumber = this.voucher.voucher_number;
                        this.voucherParams.tourNumber = this.voucher.tour_number;
                        this.voucherParams.travelGroupName = this.voucher.travel_group_name;
                        this.voucherParams.docId = this.voucher.doc_id;
                        this.voucherParams.voucherTypeId = this.voucher.voucher_type_id;
                        this.voucherParams.voucherTypeName = this.voucher.voucher_type_name;
                        this.voucherParams.transactionDate = new Date(
                            this.voucher.transaction_date
                        );
                        this.voucherParams.use = this.voucher.use;
                        this.voucherParams.voucherName = this.voucher.voucher_name;
                        this.voucherParams.accountName = this.voucher.account_name;
                        this.voucherParams.totalAmount = this.voucher.total_amount;
                        this.voucherParams.personInCharge = this.voucher.person_in_charge;
                        this.voucherParams.note = this.voucher.note;
                        this.voucherParams.currencyId = this.voucher.currency_id || Constants.JPY.id;

                        return () =>
                            import(
                                `../Voucher/Add/Temp_` + templateId + `.vue`
                            );
                    }
                }
                return null;
            },
            set: function (newValue) {
                this.modeEdit = newValue;
            },
        },
    },
    beforeMount () {
        this.switchScreen(!Utils.isEmptyStr(this.$route.query.screenType) ? this.$route.query.screenType : 1);
    },
    methods: {
        setErrorMessage () {
        },
        // ツアー検索後処理(証憑検索)
        listVouchers () {
            this.reset();
            this.setVoucherType();
            return VoucherService.subContracts(this.voucherType).then(response => {
                if (response.status == 423) {
                    StorageService.saveExpired();
                    AuthService.doLogout();
                } else if (response.status != 200) {
                    const errCode = Utils.getErrorCode(response);
                    if (errCode) {
                        const msg = this.$root.$t("error.error_code_" + errCode);
                        this.$toasted.error(msg, {icon: 'fa-exclamation-triangle'});
                    }
                } else {
                    if (!Utils.isEmptyObj(response.data)) {
                        this.contracts = this.formatContract(response.data);
                    } else {
                        this.listVoucher = [];
                        let msg = this.$root.$t("general.no_data");
                        this.$toasted.success(msg, {});
                    }
                }
            }).catch (err => {
                this.errorMessage = this.$root.$t("error.error_unknown");
            });
        },
        // 再検索
        updateTourInfo () {
            this.allReset();
            this.forceRerenderSearchTour();
            this.listVouchers();
            this.tourInfo = JSON.parse(StorageService.getTour());
        },

        forceRerenderSearchTour () {
            this.renderSearchTour = false;
            this.$nextTick(() => {
                this.renderSearchTour = true;
            });
        },

        // 証憑詳細表示
        detailContract (id) {
            this.reset();
            VoucherService.details(id).then(response => {
                if (response.status == 423) {
                    StorageService.saveExpired();
                    AuthService.doLogout();
                } else if (response.status != 200) {
                    const errCode = Utils.getErrorCode(response);
                    if (errCode) {
                        const msg = this.$root.$t("error.error_code_" + errCode);
                        this.$toasted.error(msg, {icon: 'fa-exclamation-triangle'});
                    }
                } else {
                    if (!Utils.isEmptyObj(response.data)) {
                        this.modeDetails = true;
                        this.modeEdit = false;
                        this.component = this.modeDetails;
                        this.voucher = response.data;
                        this.voucherTypeId = this.voucher.voucher_type_id;
                        this.setErrorMessage("");
                    } else {
                        let msg = this.$root.$t("general.no_data");
                        this.$toasted.success(msg, {});
                    }
                }
            }).catch (err => {
                this.errorMessage = this.$root.$t("error.error_unknown");
            });
        },

        // カメラアイコン(証憑取込) start
        addVoucherCamera () {
            this.reset();
            this.setVoucherType();
            this.selectFiles();
        },
        selectFiles () {
            $("#uploadFileModal").modal("show");
        },
        setListFiles (files) {
            this.uploadFiles = files;
        },
        showThumb (file) {
            this.file = file;
            $("#ShowImg").modal("show");
        },
        previewFiles () {
            $("#uploadFileModal").modal("hide");
            this.previewFileUpload = true;
            this.num += 1;
        },
        goAddVoucher (data = "") {
            this.previewFileUpload = false;
            this.modeAdd = true;
            this.ocrData = data;
        },
        voucherSuccess (id) {
            this.reset();
            this.listVouchers();
            return this.detailContract(id);
        },

        setVoucher () {
            this.$refs.addComponent.setVoucher();
        },

        showPreInputCopyModal () {
            this.$refs.preInputCopy.setPreInputList();
            $("#preInputCopyModal").modal("show");
        },
        // カメラアイコン end

        // タブメニュー切替
        switchScreen (screenType) {
            this.allReset();
            this.screenType = screenType;
            this.listVouchers(this.screenType);
        },

        formatContract(datas) {
            const result = [];
            let dateGroup = DateUtils.formatDateYYYYMM(new Date(datas[0].transaction_date));
            let contracts = [];
            for (const row of datas) {
                const dateYYYYMM = DateUtils.formatDateYYYYMM(new Date(row.transaction_date));
                if (dateGroup != dateYYYYMM) {
                    const resultRow = {
                        month: dateGroup,
                        contracts: contracts,
                    };
                    result.push(resultRow);
                    dateGroup = dateYYYYMM;
                    contracts = [];
                }
                contracts.push(row);
            }
            const resultRow = {
                month: dateGroup,
                contracts: contracts,
            };
            result.push(resultRow);
            return result;
        },

        editVoucher () {
            this.modeDetails = false;
            this.modeEdit = true;
        },

        setVoucherType () {
            if (this.screenType == Constants.SubContractScreenType) {
                this.voucherType = Constants.VoucherType.contract_outsourcing.id;
            } if (this.screenType == Constants.ChangeContractScreenType) {
                this.voucherType = Constants.VoucherType.change_contract.id;
            } else if (this.screenType == Constants.OtherContractScreenType) {
                this.voucherType = Constants.VoucherType.contract_other.id;
            } else if (this.screenType == Constants.PartnerContractScreenType) {
                this.voucherType = Constants.VoucherType.partner_contract.id;
            };
        },
        reset () {
            this.errorMessage = "";
            this.voucherType = "";
            this.uploadFiles = [];
            this.previewFileUpload = false;
            this.num = 0;
            this.modeAdd = false;
            this.modeDetails = false;
            this.modeEdit = false;
        },
        allReset () {
            this.reset();

            this.contracts = [];
        },
        isSubContract () {
            return this.screenType == Constants.SubContractScreenType || this.screenType == Constants.ChangeContractScreenType;
        },
    },
    watch: {
        $route (to, from) {
            if (!Utils.isEmptyStr(to.query.screenType) && !Utils.isEmptyStr(from.query.screenType) && to.query.screenType != from.query.screenType) {
                this.switchScreen(to.query.screenType);
            }
        }
    },
};

</script>



// WEBPACK FOOTER //
// src/views/components/pc/Voucher/SubContract.vue